import React, { useEffect } from 'react';
import { Col, Row, Input, Dropdown, Typography, Button } from 'antd';
import './jobtemplates.css';
import history from '../../../routes/history';
import Templates from './components/Templates/templates';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import { getJobTemplates, updateJobsReset } from '../../../redux/actions';
import Loader from '../../../components/Loading/Loader';

const JobTemplate = () => {

  const location = useLocation(); 
  const { Text } = Typography
  const dispatch = useDispatch();

  const loading = useSelector(state => state.postJObReeducer.loading);
  useEffect(() => {
    dispatch(getJobTemplates({ type: 'saved', JobOrderTypeName: location.state?.JobOrderTypeName || location.state?.PermanentJob ? 'Permanent' : 'Contract' }));
  }, [])

  return (
    <>
      {
        <Col className='template'>
          <div className='parent-column'>
            <Col xs={24} className='above-text'>
              <div>
                <p className='heading'>Post a job</p>
              </div>
              <div style={{ marginTop: '5px', textAlign: "initial" }}>
                <div>
                  Post an open job and skills you’re looking for to get matched with the best candidates for the job.
                </div>
              </div>
            </Col>

            <Templates style={{ background: 'yellow' }} />

          </div>
          <Col className='button-column' xs={24} lg={10} sm={24} md={10}>
            <Button className='main-button' onClick={() => {
              history.push({
                pathname: location.state.PermanentJob ? '/per-gig' : '/contract-gig',
                state: {
                  ...(location?.state || {}),
                  Title: "",
                  FacilityName: "",
                  Skills: "",
                  Industries: "",
                  GigDuration: "",
                  Location: "",
                  Experience: "",
                  from: 'Templates',
                  PermanentJob: location.state.PermanentJob ? true : false
                }
              })
              dispatch(updateJobsReset())
            }
            }>
              <div className='main-btn-text'>Create a new job listing</div>
            </Button>
          </Col>
        </Col>
      }
    </>
  )
}
export default JobTemplate;